import { render } from "./ProGuardados.vue?vue&type=template&id=cc573996&scoped=true"
import script from "./ProGuardados.vue?vue&type=script&lang=js"
export * from "./ProGuardados.vue?vue&type=script&lang=js"

import "./ProGuardados.vue?vue&type=style&index=0&id=cc573996&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cc573996"

export default script